import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { takeEvery, put, takeLatest } from 'redux-saga/effects';
import { select, call } from 'typed-redux-saga';
import { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } from 'libs/utils/localStorage';
import * as api from 'data/api';
import { HttpStatus, ResponseCode } from 'data/api/response-codes';
import * as sessionSelectors from 'state/session/selectors';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { UiState } from 'constants/ui';
import { LEGAL_CODE_FIELD } from 'constants/business-accounts';
import { transformBusinessRegistrationToDto, transformLegalEntity, transformPaymentsIdentityConfiguration } from './transformers';
import * as selectors from './selectors';
import { initialState, actions } from './slice';
import * as statelessActions from './actions';
import { REGISTRATION_FORM_STORAGE_KEY, BusinessDetailsField } from './constants';
export function* loadRegistrationDefaultValues() {
  const currentUser = yield* select(sessionSelectors.getUser);
  const storageData = getLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY);
  if (!storageData && !currentUser) return;

  if (storageData) {
    let registration;

    try {
      registration = JSON.parse(storageData);
    } catch (exception) {
      registration = _objectSpread({}, initialState.registration);
    }

    yield put(actions.storeRegistration(registration));
  }

  if (currentUser) {
    yield put(actions.setInitialValuesFromUserDto(currentUser));
  }
}
export function* submitRegistration(_ref) {
  let {
    payload: {
      registrationFields
    },
    meta: {
      successCallback
    }
  } = _ref;
  const DsaAbTest = yield* select(getAbTestByName('dsa_test'));
  const isDsaTestEnabled = (DsaAbTest === null || DsaAbTest === void 0 ? void 0 : DsaAbTest.variant) === 'on';
  yield put(actions.setUiState(UiState.Pending));
  yield put(actions.storeRegistration(registrationFields));
  const registration = yield* select(selectors.getRegistration);
  setLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY, JSON.stringify(registration));
  const response = yield* call(isDsaTestEnabled ? api.submitBusinessRegistrationDsa : api.submitBusinessRegistration, transformBusinessRegistrationToDto(registration));

  if ('errors' in response) {
    yield put(actions.setUiState(UiState.Failure));
    yield put(actions.setErrors(response.errors));

    if (response.code === ResponseCode.ServerError || response.status === HttpStatus.InternalError || response.status === HttpStatus.TooManyRequests || response.status === HttpStatus.UnprocessableEntity) {
      yield put(actions.setShowGeneralError());
    }

    return;
  }

  yield put(actions.setUiState(UiState.Success));
  yield put(actions.clearErrors());
  successCallback();
  removeLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY);
}
export function* updateRegistration(_ref2) {
  let {
    payload: {
      registrationFields
    },
    meta: {
      successCallback,
      validate
    }
  } = _ref2;
  const DsaAbTest = yield* select(getAbTestByName('dsa_test'));
  const isDsaTestEnabled = (DsaAbTest === null || DsaAbTest === void 0 ? void 0 : DsaAbTest.variant) === 'on';
  yield put(actions.storeRegistration(registrationFields));
  const registration = yield* select(selectors.getRegistration);
  setLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY, JSON.stringify(registration));

  if (validate) {
    yield put(actions.setUiState(UiState.Pending));
    const response = yield* call(isDsaTestEnabled ? api.validateBusinessRegistrationDsa : api.validateBusinessRegistration, transformBusinessRegistrationToDto(registrationFields));

    if ('errors' in response) {
      yield put(actions.setUiState(UiState.Failure));
      yield put(actions.setErrors(response.errors));

      if (response.code === ResponseCode.ServerError || response.status === HttpStatus.InternalError || response.status === HttpStatus.TooManyRequests || response.status === HttpStatus.UnprocessableEntity) {
        yield put(actions.setShowGeneralError());
      }

      return;
    }
  }

  yield put(actions.setUiState(UiState.Idle));
  yield put(actions.clearErrors());
  successCallback();
}
export function* updateLegalEntity(_ref3) {
  let {
    payload: {
      legalCode
    }
  } = _ref3;
  yield put(actions.setLegalEntityUiState(UiState.Pending));
  yield put(actions.setLegalCode({
    legalCode
  }));
  let registration = yield* select(selectors.getRegistration);
  setLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY, JSON.stringify(registration));
  const response = yield* call(api.getLegalEntity, legalCode);

  if ('errors' in response) {
    yield put(actions.setLegalEntityUiState(UiState.Failure));

    if (response.code === ResponseCode.ValidationError) {
      const errors = response.errors.map(error => ({
        field: error.field === LEGAL_CODE_FIELD ? BusinessDetailsField.LegalCode : error.field,
        value: error.value
      }));
      yield put(actions.setErrors(errors));
    }

    if (response.code === ResponseCode.ServerError || response.status === HttpStatus.InternalError) {
      yield put(actions.setShowGeneralError());
    }

    return;
  }

  const legalEntity = transformLegalEntity(response.legal_entity);
  yield put(actions.setLegalEntity(legalEntity));
  yield put(actions.setLegalEntityUiState(UiState.Success));
  yield put(actions.clearErrors());
  registration = yield* select(selectors.getRegistration);
  setLocalStorageItem(REGISTRATION_FORM_STORAGE_KEY, JSON.stringify(registration));
}
export function* fetchConfiguraton() {
  const response = yield* call(api.getPaymentsIdentityFormConfiguration);

  if ('errors' in response) {
    yield put(statelessActions.fetchFormConfigurationFailure());
    return;
  }

  const configuration = transformPaymentsIdentityConfiguration(response);
  yield put(actions.setConfiguration({
    configuration
  }));
}
export function* submitKybForm() {
  const kybData = yield* select(selectors.getKybData);

  if (!kybData) {
    yield put(actions.setShowGeneralError());
    return;
  }

  const response = yield* call(api.submitPaymentsIdentity, kybData);

  if ('errors' in response) {
    yield put(actions.setErrors(response.errors));
    if (!response.errors.length) yield put(actions.setShowGeneralError());
    return;
  }

  const configuration = transformPaymentsIdentityConfiguration(response);
  yield put(actions.setConfiguration({
    configuration
  }));
  yield put(actions.clearRegistration());
  yield put(actions.setUiState(UiState.Success));
}
export default function* saga() {
  yield takeEvery(statelessActions.loadRegistrationDefaultValues, loadRegistrationDefaultValues);
  yield takeEvery(statelessActions.submitRegistration, submitRegistration);
  yield takeEvery(statelessActions.updateRegistration, updateRegistration);
  yield takeEvery(statelessActions.updateLegalEntity, updateLegalEntity);
  yield takeLatest(statelessActions.fetchFormConfigurationRequest, fetchConfiguraton);
  yield takeLatest(statelessActions.submitKybFormRequest, submitKybForm);
}